import { render } from "./EmailForm.vue?vue&type=template&id=142671c2&scoped=true"
import script from "./EmailForm.vue?vue&type=script&lang=js"
export * from "./EmailForm.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-142671c2"

export default script